export default __webpack_public_path__ + "static/media/fans_2.5069ef46.png";